module.exports = __webpack_public_path__ + "img/logo_straight.0a53e41d.svg";